import { ResourcesConfig } from 'aws-amplify';

const {
    REACT_APP_COGNITO_CLIENT_ID,
    REACT_APP_COGNITO_APP_DOMAIN,
    REACT_APP_COGNITO_USERPOOL_ID,
    // REACT_APP_COGNITO_REDIRECT_URI,
    REACT_APP_COGNITO_REDIRECT_URI_SIGNOUT,
  } = process.env;

const REDIRECT_URI = `${window.location.origin}/login/oauth2/code/cognito`;

export const AmplifyConfig: ResourcesConfig = {
    Auth: {
        Cognito: {
            userPoolId: REACT_APP_COGNITO_USERPOOL_ID as string,
            userPoolClientId: REACT_APP_COGNITO_CLIENT_ID as string,
            loginWith: {
                oauth: {
                    domain: REACT_APP_COGNITO_APP_DOMAIN as string,
                    scopes: ['email', 'openid','aws.cognito.signin.user.admin'],
                    redirectSignIn: [REDIRECT_URI as string],
                    redirectSignOut:[REACT_APP_COGNITO_REDIRECT_URI_SIGNOUT as string],
                    responseType: 'token',
                    
                }
            }
        }
    }
}